"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DualDropdownContainer = exports.DualDropdown = exports.Line = exports.OuterContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  width: 100%;\n  height: 48px;\n  cursor: pointer;\n  user-select: none;\n  :focus {\n    outline: 0;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  width: 100%;\n  height: 48px;\n  cursor: pointer;\n  user-select: none;\n  :focus {\n    outline: 0;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  width: 0px;\n  height: 24px;\n  border: solid 0.5px ", ";\n"], ["\n  width: 0px;\n  height: 24px;\n  border: solid 0.5px ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyDropdown = require("buoy-dropdown");

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var OuterContainer = exports.OuterContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__OuterContainer",
  componentId: "sc-1q6vxev-0"
})(_templateObject, _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.neutralLightest);

var Line = exports.Line = _styledComponents2.default.div.withConfig({
  displayName: "src__Line",
  componentId: "sc-1q6vxev-1"
})(_templateObject2, _buoyTheme.colors.neutral);

var DualDropdown = function DualDropdown(_ref) {
  var dropdownRef = _ref.dropdownRef,
      dropUp = _ref.dropUp,
      errorLeft = _ref.errorLeft,
      errorRight = _ref.errorRight,
      forceShowErrorLeft = _ref.forceShowErrorLeft,
      forceShowErrorRight = _ref.forceShowErrorRight,
      leftAriaLabel = _ref.leftAriaLabel,
      menuRefLeft = _ref.menuRefLeft,
      menuRefRight = _ref.menuRefRight,
      onChangeLeft = _ref.onChangeLeft,
      onChangeRight = _ref.onChangeRight,
      onClickLeft = _ref.onClickLeft,
      onClickRight = _ref.onClickRight,
      onFocusLeft = _ref.onFocusLeft,
      onFocusRight = _ref.onFocusRight,
      onKeyDown = _ref.onKeyDown,
      openedLeft = _ref.openedLeft,
      openedRight = _ref.openedRight,
      optionsLeft = _ref.optionsLeft,
      optionsRight = _ref.optionsRight,
      placeholderLeft = _ref.placeholderLeft,
      placeholderRight = _ref.placeholderRight,
      rightAriaLabel = _ref.rightAriaLabel,
      selectedLeft = _ref.selectedLeft,
      selectedRight = _ref.selectedRight,
      showErrorLeft = _ref.showErrorLeft,
      showErrorRight = _ref.showErrorRight,
      valueLeft = _ref.valueLeft,
      valueRight = _ref.valueRight,
      widthLeft = _ref.widthLeft,
      widthRight = _ref.widthRight,
      props = _objectWithoutProperties(_ref, ["dropdownRef", "dropUp", "errorLeft", "errorRight", "forceShowErrorLeft", "forceShowErrorRight", "leftAriaLabel", "menuRefLeft", "menuRefRight", "onChangeLeft", "onChangeRight", "onClickLeft", "onClickRight", "onFocusLeft", "onFocusRight", "onKeyDown", "openedLeft", "openedRight", "optionsLeft", "optionsRight", "placeholderLeft", "placeholderRight", "rightAriaLabel", "selectedLeft", "selectedRight", "showErrorLeft", "showErrorRight", "valueLeft", "valueRight", "widthLeft", "widthRight"]);

  return _react2.default.createElement(
    OuterContainer,
    { innerRef: dropdownRef, onKeyDown: onKeyDown, onBlur: props.onBlur },
    _react2.default.createElement(_buoyDropdown.Dropdown, {
      ariaLabel: leftAriaLabel,
      dropUp: dropUp,
      error: errorLeft,
      forceShowError: forceShowErrorLeft,
      focused: openedLeft,
      focusedLeft: props.focusedLeft,
      isFocused: props.focusedLeft,
      menuRef: menuRefLeft,
      noMargin: true,
      onChange: onChangeLeft,
      onClick: onClickLeft,
      onFocus: onFocusLeft,
      options: optionsLeft,
      placeholder: placeholderLeft,
      selectedLeft: selectedLeft,
      showError: showErrorLeft,
      tabIndex: "0",
      value: valueLeft,
      width: widthLeft
    }),
    _react2.default.createElement(Line, null),
    _react2.default.createElement(_buoyDropdown.Dropdown, {
      ariaLabel: rightAriaLabel,
      dropUp: dropUp,
      error: errorRight,
      forceShowError: forceShowErrorRight,
      focused: openedRight,
      focusedRight: props.focusedRight,
      isFocused: props.focusedRight,
      menuRef: menuRefRight,
      noMargin: true,
      onChange: onChangeRight,
      onClick: onClickRight,
      onFocus: onFocusRight,
      options: optionsRight,
      placeholder: placeholderRight,
      selectedRight: selectedRight,
      selectedLeft: selectedLeft,
      showError: showErrorRight,
      tabIndex: "0",
      value: valueRight,
      width: widthRight
    })
  );
};

exports.DualDropdown = DualDropdown;

var DualDropdownContainer = exports.DualDropdownContainer = function (_React$Component) {
  _inherits(DualDropdownContainer, _React$Component);

  function DualDropdownContainer(props) {
    _classCallCheck(this, DualDropdownContainer);

    var _this = _possibleConstructorReturn(this, (DualDropdownContainer.__proto__ || Object.getPrototypeOf(DualDropdownContainer)).call(this, props));

    _this.onKeyDown = function (e) {
      var _this$state = _this.state,
          openedLeft = _this$state.openedLeft,
          openedRight = _this$state.openedRight,
          focusedLeft = _this$state.focusedLeft,
          focusedRight = _this$state.focusedRight;
      var _this$props = _this.props,
          optionsLeft = _this$props.optionsLeft,
          optionsRight = _this$props.optionsRight,
          valueLeft = _this$props.valueLeft,
          valueRight = _this$props.valueRight;

      var key = e.key;
      var keyOpts = ["Tab", "Enter", "Up", "ArrowUp", "Down", "ArrowDown", "Escape"];
      // open dropdowns on enter/arrowdown/space
      if (focusedLeft && (key === "Enter" || key === "ArrowDown" || e.keyCode === 32)) _this.setState({ openedLeft: true });
      if (focusedRight && (key === "Enter" || key === "ArrowDown" || e.keyCode === 32)) _this.setState({ openedRight: true });

      if (!openedLeft && !openedRight || !keyOpts.includes(key) && e.keyCode !== 32) return;
      var options = openedLeft ? optionsLeft : optionsRight;
      var menu = openedLeft ? _this.menuLeft : _this.menuRight;
      var value = openedLeft ? valueLeft : valueRight;

      var index = options.findIndex(function (o) {
        return o.value === value;
      });
      var option = options[index];

      // close on escape and reset dropdown to first option
      if (key === "Escape" && openedLeft) {
        _this.onClickLeft(e);
        return;
      } else if (key === "Escape" && openedRight) {
        _this.onClickRight(e);
        return;
      }
      // allow selection on enter/space
      if (openedLeft && (key === "Enter" || e.keyCode === 32)) _this.onClickLeft(e);
      if (openedRight && (key === "Enter" || e.keyCode === 32)) _this.onClickRight(e);

      if (key === "Tab" && !e.shiftKey) {
        _this.setOpen(false, false);
        if (!(key == "Tab" && e.shiftKey)) {
          e.target.blur();
        }
        return;
      }

      e.preventDefault();

      // if key down and none selected, select option 1
      if ((key === "Down" || key === "ArrowDown") && !option) {
        option = options[0];
        menu.children[0].scrollIntoView();
        menu.scrollTop = menu.children[0].offsetTop;
        // if key down and not last option, select next option
      } else if (option && (key === "Down" || key === "ArrowDown") && option !== options[options.length - 1]) {
        option = options[index + 1];
        menu.scrollTop = menu.children[index + 1].offsetTop;
        // if key up and not first option, select prev option
      } else if (option && (key === "Up" || key === "ArrowUp") && option !== options[0]) {
        option = options[index - 1];
        menu.scrollTop = menu.children[index - 1].offsetTop;
      }
      if (openedLeft) {
        _this.onChangeLeft(option);
      } else if (openedRight) {
        _this.onChangeRight(option);
      }
    };

    _this.onChangeLeft = function (option) {
      _this.setState({ selectedLeft: option });
      if (_this.props.onChangeLeft) _this.props.onChangeLeft(option);
    };

    _this.onChangeRight = function (option) {
      _this.setState({ selectedRight: option });
      if (_this.props.onChangeRight) _this.props.onChangeRight(option);
    };

    _this.onClickLeft = function (e) {
      var open = _this.state.openedLeft;

      if (open) {
        var selected = _this.props.optionsLeft.find(function (o) {
          return o.text === e.target.innerText;
        });
        if (e.key === "Escape") selected = _this.props.optionsLeft[0];
        if (selected) _this.onChangeLeft(selected);
      }

      _this.setOpen(!open, false);
    };

    _this.onClickRight = function (e) {
      var open = _this.state.openedRight;

      if (open) {
        var selected = _this.props.optionsRight.find(function (o) {
          return o.text === e.target.innerText;
        });
        if (e.key === "Escape") selected = _this.props.optionsRight[0];
        if (selected) _this.onChangeRight(selected);
      }

      _this.setOpen(false, !open);
    };

    _this.onFocusLeft = function () {
      _this.setState({ focusedLeft: true, focusedRight: false });
    };

    _this.onFocusRight = function () {
      _this.setState({ focusedLeft: false, focusedRight: true });
    };

    _this.setOpen = function (left, right) {
      if (typeof window !== "undefined") {
        var dropUp = _this.dropdown ? window.innerHeight - (_this.dropdown.getBoundingClientRect().bottom + (210 - _this.dropdown.getBoundingClientRect().height)) <= 0 : false;

        _this.setState(_extends({}, _this.state, {
          openedLeft: left,
          openedRight: right,
          dropUp: dropUp
        }));
      }
    };

    _this.handleClickOutside = function () {
      _this.setOpen(false, false);
    };

    _this.onBlur = function () {
      _this.setState({ focusedLeft: false, focusedRight: false });
    };

    _this.state = {
      openedLeft: false,
      openedRight: false,
      focusedLeft: false,
      focusedRight: false,
      selectedLeft: null,
      selectedRight: null,
      dropUp: false
    };
    return _this;
  }

  _createClass(DualDropdownContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _state = this.state,
          openedLeft = _state.openedLeft,
          openedRight = _state.openedRight;
      var _props = this.props,
          valueLeft = _props.valueLeft,
          valueRight = _props.valueRight,
          optionsLeft = _props.optionsLeft,
          optionsRight = _props.optionsRight;


      if (!prevState.openedLeft && openedLeft) {
        // We just focused the left dropdown, scroll to the selected option.
        var index = optionsLeft.findIndex(function (o) {
          return o.value === valueLeft;
        });

        if (index >= 0 && this.menuLeft) {
          this.menuLeft.scrollTop = this.menuLeft.children[index].offsetTop;
        }
      } else if (!prevState.openedRight && openedRight) {
        // We just focused the right dropdown, scroll to the selected option.
        var _index = optionsRight.findIndex(function (o) {
          return o.value === valueRight;
        });

        if (_index >= 0 && this.menuRight) {
          this.menuRight.scrollTop = this.menuRight.children[_index].offsetTop;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(DualDropdown, _extends({
        dropdownRef: function dropdownRef(d) {
          return _this2.dropdown = d;
        },
        onClickRight: this.onClickRight,
        onClickLeft: this.onClickLeft,
        onChangeLeft: this.onChangeLeft,
        onChangeRight: this.onChangeRight,
        onKeyDown: this.onKeyDown,
        menuRefRight: function menuRefRight(m) {
          return _this2.menuRight = m;
        },
        menuRefLeft: function menuRefLeft(m) {
          return _this2.menuLeft = m;
        },
        onFocusLeft: this.onFocusLeft,
        onFocusRight: this.onFocusRight,
        onBlur: this.onBlur
      }, this.state, this.props));
    }
  }]);

  return DualDropdownContainer;
}(_react2.default.Component);

DualDropdownContainer.propTypes = {
  errorLeft: _propTypes2.default.string,
  errorRight: _propTypes2.default.string,
  forceShowErrorLeft: _propTypes2.default.bool,
  forceShowErrorRight: _propTypes2.default.bool,
  onChangeLeft: _propTypes2.default.func.isRequired,
  onChangeRight: _propTypes2.default.func.isRequired,
  optionsLeft: _propTypes2.default.array.isRequired,
  optionsRight: _propTypes2.default.array.isRequired,
  placeholderLeft: _propTypes2.default.string.isRequired,
  placeholderRight: _propTypes2.default.string.isRequired,
  showErrorLeft: _propTypes2.default.bool,
  showErrorRight: _propTypes2.default.bool,
  valueLeft: _propTypes2.default.any,
  valueRight: _propTypes2.default.any,
  widthLeft: _propTypes2.default.string,
  widthRight: _propTypes2.default.string
};

exports.default = (0, _reactOnclickoutside2.default)(DualDropdownContainer);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-dual-dropdown/dist/index.js
// module id = 402
// module chunks = 168707334958949